import React, { useEffect, useCallback } from 'react';
import {
	useAjax,
	XhrStatus,
	InputField
} from '@bosch/bt-ui';

import './CSRManagementTableDesc.css';
import { useNavigate } from 'react-router-dom';
import withErrorHandler from '../../components/ErrorHandler';
import CenterLoadingContainer from '../../components/CenterLoadingContainer';

const CSRManagementTableDesc = (props) => {
	const {
		token,
		isLoggedIn,
		ipAddress,
		csrInfo,
		updateCSRInfo
	} = props;

	const navigate = useNavigate();
	const [returnResult, status, runAjaxInner, response] = useAjax(XhrStatus.Initial);

	const onFormSubmit = useCallback(
		() => {
			if (isLoggedIn()) {
				console.log(csrInfo[ipAddress])
				if (csrInfo[ipAddress].description !== csrInfo[ipAddress].oldDescription) {
					const headers = {
						'Authorization': 'Bearer ' + token.token
					}
					const data = {
						'Description': csrInfo[ipAddress].description
					}

					runAjaxInner('POST', SUPPORTCONSOLE_API_URL + '/api/csrmanagement/v1/csrs/' + encodeURIComponent(ipAddress) + '/desc', null, data, headers);
				}
			}
			else {
				navigate('/');
			}
		},
		[token, runAjaxInner, isLoggedIn, navigate, csrInfo, ipAddress]
	);

	useEffect(
		() => {
			if (returnResult && csrInfo[ipAddress].description !== csrInfo[ipAddress].oldDescription) {
				console.log(returnResult, csrInfo[ipAddress]);
				if (returnResult.status === 'Success') {
					// Update description
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'oldDescription', value:returnResult.data.description}})
				}
				else {
					// Recover description
					updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'description', value:csrInfo[ipAddress].oldReleaseVersion}})
				}
				// Report the process status
				updateCSRInfo({ipAddress:ipAddress, updateInfo:{fieldName:'csrStatus', value:returnResult.data.csrStatus}})

				// Not sure how to reset returnResult
				runAjaxInner('POST', SUPPORTCONSOLE_API_URL + '/api/csrmanagement/v1/csrs/reset', null, null,  {'Authorization': 'Bearer ' + token.token});
			}
		},
		[returnResult, ipAddress, csrInfo, updateCSRInfo, runAjaxInner, token]
	);

	return (
		status === XhrStatus.InProgress ?
			<CenterLoadingContainer />
		:
			<InputField
				inputType="text"
				fieldName="description"
				htmlAttributes={{
					onChange: (updateInfo) => {updateCSRInfo({ipAddress:ipAddress, updateInfo:updateInfo});},
					onBlur: () => {onFormSubmit()},
					value: csrInfo[ipAddress].description
				}}
			/>
	);
};

export default withErrorHandler(React.memo(CSRManagementTableDesc));